export default __webpack_public_path__ + "static/media/b-1.5932c4ab.png";